export const InvoiceErrors: Record<string, string> = {
  'It is necessary to enable NFE settings to be able to create an NFE.':
    'É necessário habilitar as configurações da NF-e para poder criar uma NF-e.',
  'It is necessary to enable NFC settings to be able to create an NFC.':
    'É necessário ativar as configurações de NFC-e para poder criar um NFC-e.',
  'It is necessary to enable NFS settings to be able to create an NFS.':
    'É necessário ativar as configurações de NFS para poder criar um NFS.',
  'date não foi encontrado': 'XML não encontrado',
  'TaxRegime not found.': 'Regime tributário não encontrado',
};
